import React from 'react';
import Form from '../Modules/form/components/Form';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import DocumentTitle from 'react-document-title';
import Breadcrumbs from './Breadcrumbs';
import TitleBar from '../Modules/layout/components/TitleBar';
import Grid from '@material-ui/core/Grid';
import TextInput from '../Modules/form/components/TextInput';
import SubmitButton from '../Modules/form/components/SubmitButton';
import { administrationSettingSchema } from '../Modules/administration/schema';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useCanWrite } from '../Modules/abilities/hooks';
import { ADMINISTRATION_SETTING_RESOURCE } from '../Modules/api/resources';
import LoadingBox from '../Modules/loading/components/LoadingBox';
import { useInitialValuesTrigger } from '../Modules/form/hooks';
import {
    storeAdministrationSetting,
    updateAdministrationSetting,
    useAdministrationSettings,
    selectAllAdministrationSettings,
} from '../Modules/administration/administrationSettingSlice';
import { useSelector } from 'react-redux';


/**
 * Administration Page
 */
const AdministrationPage = () => {

    const SETTINGS_ID = 1;
    const DEFAULT_DAYS_BEFORE_NOTIFICATION_EMPLOYEE = 7;
    const DEFAULT_DAYS_BEFORE_NOTIFICATION_AGENCY = 9;
    const canWriteAdministrationSetting = useCanWrite(ADMINISTRATION_SETTING_RESOURCE);

    const dispatch = useDispatch();
    const { loading: administrationSettingLoading } = useAdministrationSettings();

    // get all administration setting values or default values if not set yet
    const administrationSettings = useSelector(selectAllAdministrationSettings);
    // sort by id descending to get the record with the highest id
    const activeAdministrationSetting = useMemo(() => {
        if (!administrationSettings || administrationSettings.length === 0) return null;
        return [...administrationSettings].sort((a, b) => b.id - a.id)[0];
    }, [administrationSettings]);

    const init = useMemo(() => {
         return {
             furtherAssignmentCheckDaysBaseEmployee: activeAdministrationSetting?.further_assignment_check_days_base_employee || DEFAULT_DAYS_BEFORE_NOTIFICATION_EMPLOYEE,
             furtherAssignmentCheckDaysBaseAgency: activeAdministrationSetting?.further_assignment_check_days_base_agency || DEFAULT_DAYS_BEFORE_NOTIFICATION_AGENCY,
         };
    },
    [ activeAdministrationSetting ]);

    const loading = useMemo(() => {
            return (
                administrationSettingLoading === undefined ||
                administrationSettingLoading
            );
        }, [administrationSettingLoading]);

    const initialValues = useInitialValuesTrigger(activeAdministrationSetting, init, loading);

    const handleSubmit = useCallback(
        (values) => {
            const id = activeAdministrationSetting?.id || SETTINGS_ID;
            const prepped = { ...values, id };
            if (!activeAdministrationSetting) {
                return dispatch(storeAdministrationSetting(prepped));
            } else {
                return dispatch(updateAdministrationSetting(prepped));
            }
        },
        [dispatch, activeAdministrationSetting]
    );

    return (
        <>
            <DocumentTitle title="Administration" />
            <Container>
                <Breadcrumbs label="Administration" />
                <LoadingBox loading={loading} marginTop={2} marginBottom={2}>
                    <Form
                        schema={administrationSettingSchema}
                        initialValues={initialValues}
                        onSubmit={handleSubmit}
                        subject={activeAdministrationSetting || ADMINISTRATION_SETTING_RESOURCE}
                        enableReinitialize={true}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TitleBar>Administration</TitleBar>
                            </Grid>
                            <Grid item xs={6}>
                                <TitleBar>Automatische Benachrichtigungen</TitleBar>
                                <Grid item xs={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <TextInput name="furtherAssignmentCheckDaysBaseEmployee" label="Tage vor Ende der letzten BK. Automatische Benachrichtigung an Mitarbeiter" disabled={!canWriteAdministrationSetting} fullWidth />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextInput name="furtherAssignmentCheckDaysBaseAgency" label="Tage vor Ende der letzten BK. Automatische Benachrichtigung an Agentur" disabled={!canWriteAdministrationSetting} fullWidth/>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Box textAlign="right" mt={1}>
                            <SubmitButton disabled={!canWriteAdministrationSetting} />
                        </Box>
                    </Form>
                </LoadingBox>
            </Container>
        </>
    );
};

export default AdministrationPage;